export default "__VITE_ASSET___rs0KstFpz7xtOUuuLO2aw__"